import React from 'react';
import { ActionItem } from '../../../../types';
import styles from './static-content-template.module.css';

function StaticContentTemplate({ actionItem }: { actionItem: ActionItem }) {
  const content = actionItem.body?.content_blocks;
  const filterContent = content?.filter(
    contentData => contentData.content_type === 'paragraph-block'
  );
  const newContents = filterContent?.map(contentData => contentData.text);

  return (
    <>
      {newContents?.map((newContent, idx) => (
        <p
          key={idx}
          className={styles.text}
          dangerouslySetInnerHTML={{ __html: newContent }}
          data-testid="static-paragraph"
        />
      ))}
    </>
  );
}

export default StaticContentTemplate;
